export default {
  INSTRUCTOR: 'instructor',
  LOCATION:   'location'
};
